<!--电费账单详情列表-->
<template :visible.sync="addOwnerShow" :title="title">
  <div style="height: 100%;background-color: white;">
    <div style="height: 100%;">
      <div style="width: 100%;display: flex;align-items: center;justify-content: space-between;padding:10px 0;">
        <el-button icon="el-icon-d-arrow-left" size="mini" @click="backToOrder" class="return_button">返回</el-button>
        <h1 style="font-size:30px;text-align: center;color: #9f9f9f">账单详情</h1>
        <div style="width: .2rem;height: .2rem;"></div>
      </div>
      <div class="infoListContainer">
        <el-table :data="dataList" height="800" border style="width: 100%" v-loading="loading">
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" width="90" label="序号">
          </el-table-column>
          <el-table-column prop="userName" label="业主姓名">
          </el-table-column>
          <el-table-column prop="deviceName" label="表名">
          </el-table-column>
          <el-table-column prop="createTime" label="抄表日期">
            <template slot-scope="scope">
              <span>{{new Date(scope.row.createTime).format("yyyy-MM-dd hh:mm:ss")}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="accountType" label="付费类型">
            <template slot-scope="scope">
              <span>{{scope.row.accountType==0?"月结":"预付费"}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Time" label="实际用电时间" width="262">
          </el-table-column>
          <el-table-column prop="basicFee" label="基本电费(元)">
            <template slot-scope="scope">
              <span>{{editMoneyYan(scope.row.basicFee)}}</span>
            </template>
          </el-table-column>
          <!--					<el-table-column prop="electricFee" label="电度电费(元)">-->
          <!--						<template slot-scope="scope">-->
          <!--							<span>{{editMoneyYan(scope.row.electricFee)}}</span>-->
          <!--						</template>-->
          <!--					</el-table-column>-->
          <el-table-column prop="freeQuantity" label="免费电量">
            <template slot-scope="scope">
              <span>{{editMoneyYan(scope.row.freeQuantity)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="electricQuantity" label="用电量(kWh)">
          </el-table-column>
          <el-table-column prop="amount" label="合计(元)">
            <template slot-scope="scope">
              <span>{{editMoneyYan(scope.row.amount)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="userBalance" label="本次余额(元)">
            <template slot-scope="scope">
              <span>{{editMoneyYan(scope.row.userBalance)}}</span>
            </template>
          </el-table-column>
        </el-table>
        <elPagination :total="totalSize" :pageSize="pageSize" @pageindexChange="pageindexChange"
          @handleSizeChange="handleSizeChange" />
      </div>
    </div>
  </div>
</template>

<script>
  import infoListMultipleSelection from '@/page/system/meterReading/infoListMultipleSelection.vue'
  import singleSelection from '@/components/module/selection/singleSelection.vue'
  import billDialog from './billDialog.vue'
  import billStore from './billStore'
  import elPagination from "@/components/module/elComponents/elPagination.vue"
  export default {
    components: {
      infoListMultipleSelection,
      billDialog,
      singleSelection,
      elPagination,
    },
    props: {},
    data () {
      return {
        pageIndex: 1,
        pageSize: 20,
        totalSize: 0,
        dataList: [],
        deviceNos: '',
        ownerName: '',
        userId: this.$route.query.userId,
        state: undefined,
        filterTime: false,
        searchChange: false,
        addOwnerShow: false,
        title: "",
        meterType: this.$route.query.meterType,
        meterRunType: this.$route.query.meterRunType,
        accountType: this.$route.query.accountType,
        datetimeValue: this.$route.query.datetimeValue,
        billingMode: this.$route.query.billingMode,
        loading: false,
      }
    },
    created () {

    },
    mounted () {
      this.getDataList();
    },
    destroyed () {},
    computed: {
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      nowSelectDate () {
        return this.$store.cacheStore.getters.getNowSelectDate
      },
      nowTimeInterval () {
        return this.$store.cacheStore.getters.getBillTimeInterval
      },
      nowDateText () {
        return this.filterTime? this.nowTimeInterval.startDate.formatByDate()+' - '+this.nowTimeInterval.endDate.formatByDate():''
      },
      columns () {
        return billStore.state.columns
      },
      editOwnerName () {
        return userName => {
          return userName==null||userName==''||userName==undefined? '-':userName
        }
      },
      chargingStatusList () {
        return billStore.state.chargingStatusList
      },
      accountTypeList () {
        return billStore.state.accountTypeList
      },
      meterRunTypeList () {
        return billStore.state.meterRunTypeList
      },
      timeText () {
        return time => {
          if(time==null||time==undefined||time=='') {
            return '-'
          }
          return new Date(time).formatByTime()
        }
      },
    },
    watch: {
      nowUnit (nv,ov) {
        billStore.commit('setNowUnit',nv)
        this.getDataList(nv)
      },
      ownerName (nv,ov) {
        this.searchChange=true
      },
      state (nv,ov) {
        this.searchChange=true
      },
      filterTime (nv,ov) {
        this.searchChange=true
      },
      nowTimeInterval (nv,ov) {
        this.searchChange=true
        this.getDataList()
      }
    },
    methods: {
      editMoneyYan (a) {
        return (a/100).toFixed(2)
      },
      //当前页
      pageindexChange (val) {
        this.pageIndex=val;
        this.getDataList()
      },
      //页大小
      handleSizeChange (val) {
        this.pageSize=val;
        this.pageIndex=1;
        this.getDataList()
      },
      backToOrder () {
        history.go(-1);
        //this.$router.push('/billReport')
        this.addOwnerShow=false;
      },
      //排序
      compare (name) {
        return function(a,b) {
          var s1=a[name]+"";
          var s2=b[name]+"";
          return s1.localeCompare(s2);
        }
      },

      //lxk 时间类型排序
      sort (value) {
        return function(a,b) {
          var s1=a[value];
          var s2=b[value];
          return s1<s2? 1:-1
        }
      },
      // 获取列表信息
      getDataList () {
        if(isempty(this.nowUnit)) {
          return
        }
        if(isempty(this.datetimeValue)) {
          this.datetimeValue=['','']
        }
        if(this.searchChange) {
          this.pageIndex=1
          this.$refs.meterManagerList.pageIndex=1
          this.searchChange=false
        }
        this.loading=true
        this.$api.meterReadingApi.getElectricityBill(this.userId,this.meterType,this.nowUnit.id,this.pageIndex,this.pageSize,this.deviceNos,this.ownerName,this.state,this.datetimeValue[0],this.datetimeValue[1],this.accountType,this.meterRunType,respon => {
          this.dataList=copy(respon.dataList.sort(this.sort('createTime')))
          for(var i=0;i<respon.dataList.length;i++) {
            this.dataList[i]['Time']=this.timeText(respon.dataList[i].beginTime)+' - '+this.timeText(respon.dataList[i].endTime)
          }
          this.totalSize=respon.total
          this.loading=false
        })
      },
    }
  }
</script>

<style scoped>
  .return_button {
    margin-left: .2rem;
  }

  .infoListContainer {
    padding: 0 20px 0 20px;
    height: calc(100% - 76px);
  }
</style>